import { useMemo } from "react";
import { keyBy } from "lodash";
import apiClient from "./apiClient";
import { ENDPOINTS } from "./endpoints";
import { useQuery } from "@tanstack/react-query";
import queryKeys from "../queryKeys";

export const fetchProducts = async () => {
    const result = await apiClient.get(ENDPOINTS.products);
    return result?.data;
};

export const fetchUIProducts = async () => {
    return apiClient.get(ENDPOINTS.uiProducts);
};

export const useFetchProducts = ({ isEnabled = true, ...options } = {}) => {
    const { data, isFetched, ...rest } = useQuery({
        queryKey: queryKeys.products(),
        queryFn: fetchProducts,
        enabled: isEnabled,
        refetchOnMount: false,
        ...options,
    });

    const allRegions = useMemo(() => {
        if (!data?.length) return [];
        const regionsMap = new Map();
        data.forEach((product) => {
            const planes = product?.planes || {};
            [planes?.control?.locations, planes?.data?.locations].forEach((locations) => {
                (locations || []).forEach((region) => {
                    if (!region?.region_id) return;
                    if (!regionsMap.has(region.region_id)) {
                        regionsMap.set(region.region_id, { ...region, product_mapping: [product.product_type] });
                    } else {
                        const existing = regionsMap.get(region.region_id);
                        if (!existing.product_mapping.includes(product.product_type)) {
                            existing.product_mapping.push(product.product_type);
                        }
                    }
                });
            });
        });
        return Array.from(regionsMap.values());
    }, [data]);

    const productsById = useMemo(() => keyBy(data, "product_type"), [data]);

    return { data, isFetched, allRegions, productsById, ...rest };
};
